export default {
    user : null,
    isLoading: false,
    error: null
}